







































































































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla modal edit
 */
import i18nMessages from "./i18n/messages";
import dataService from "@/services/proveedoresAPI";
import ResponseData from "@/models/store/ProveedoresTypesData";
import { S3 } from "@/common/s3";
import GlobalMixin from "@/mixins/global";
import moment from "moment";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  props: {
    dialog: { type: Boolean, default: false },
    proveedor: { type: Object, default: {} },
    documentEdit: { type: Object, default: {} },
    docuementoSeccion: { type: Object, default: {} },
    enabledEdit: { type: Number, default: 0 },
  },
  data: () => {
    return {
      // GENERAL
      moduleName: "MODAL_NEW_EDIT",
      menu: false,
      modal: false,
      menu1: false,
      valid: false,
      enabled: false,
      disabled: true,
      docBucketKeyFileTemp: "",
      dateI: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateF: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  computed: {
    dateFormattedvigenciaIni() {
      return moment
        .utc(
          this.documentEdit.docVigenciaIni ??
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10)
        )
        .locale("es-mx")
        .format("L");
    },
    dateFormattedvigenciaFin() {
      return moment
        .utc(
          this.documentEdit.docVigenciaFin ??
            new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
              .toISOString()
              .substr(0, 10)
        )
        .locale("es-mx")
        .format("L");
    },
    rulesFile() {
      if (this.documentEdit.docID == undefined) {
        this.enabled = true;
        this.ruleFileDisable = false;
      } else {
        if (typeof this.documentEdit.docBucketKeyFile === "string") {
          this.docBucketKeyFileTemp = this.documentEdit.docBucketKeyFile;
        }
        if (this.enabledEdit == 0) {
          this.enabled = false;
          this.$emit("updateEnabledEdit");
        }
        this.ruleFileDisable = !this.enabled;
      }
      return [this.requiredFile("archivo"), this.fileExtentionValid("archivo")];
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    openDialog() {
      this.$emit("openDialog");
    },
    async save() {
      if (this.documentEdit.docID) {
        // Editar
        let fileExt = "";
        let fileName = "";
        let fileNameTem = this.docBucketKeyFileTemp;
        if (
          this.documentEdit.docBucketKeyFile != null &&
          this.documentEdit.docBucketKeyFile.size > 0
        ) {
          const fileExtention = this.getFileExtention(
            this.documentEdit.docBucketKeyFile.name
          );
          let fileNameKey =
            this.docuementoSeccion.tipoNombre.trim() +
            "_" +
            this.proveedor.userID +
            "_" +
            Date.now() +
            "." +
            fileExtention;
          const resultS3: any = await S3.upload(
            this.documentEdit.docBucketKeyFile,
            fileNameKey
          );
          if (resultS3) {
            if (this.docBucketKeyFileTemp) {
              S3.delete(this.docBucketKeyFileTemp);
            }
            fileName = resultS3.key;
            fileNameTem = fileName;
            fileExt = fileExtention;
          }
        }
        this.documentEdit.docProveedor = this.proveedor.userID;
        this.documentEdit.docTipoID = this.docuementoSeccion.documentoTipoID;
        this.documentEdit.docBucketKeyFile = fileName;
        this.documentEdit.docFileExt = fileExt;
        dataService
          .updateDocument(this.documentEdit)
          .then((Response: ResponseData) => {
            if (Response.data.data[0]) {
              this.documentEdit.docID = Response.data.data[0].id;
              this.documentEdit.docEstatusID = 1;
              this.documentEdit.docBucketKeyFile = fileNameTem;
              this.$emit(
                "notificacion",
                "Registro editado correctamente",
                "success"
              );
              this.documentEdit.docID = Response.data.data[0].id;
              this.documentEdit.docEstatusID = 1;
              this.$emit("saveItem");
            } else {
              this.$emit(
                "notificacion",
                "No se pudo editar el registro, intente de nuevo más tarde",
                "red darken-2"
              );
            }
          })
          .catch((e: Error) => {
            this.$emit(
              "notificacion",
              "No se pudo editar el registro" + e,
              "red darken-2"
            );
          });
      } else {
        // Crear
        if (
          this.documentEdit.docBucketKeyFile != null &&
          this.documentEdit.docBucketKeyFile
        ) {
          const fileExtention = this.getFileExtention(
            this.documentEdit.docBucketKeyFile.name
          );
          let fileName =
            this.docuementoSeccion.tipoNombre.trim() +
            "_" +
            this.proveedor.userID +
            "_" +
            Date.now() +
            "." +
            fileExtention;
          const resultS3: any = await S3.upload(
            this.documentEdit.docBucketKeyFile,
            fileName
          );
          if (Object.keys(resultS3).length) {
            this.documentEdit.docVigenciaIni = "";

            this.documentEdit.docVigenciaFin = "";

            if (this.documentEdit.docEsTermCond == undefined) {
              this.documentEdit.docEsTermCond = 0;
            }

            if (this.documentEdit.docOCNumero == undefined) {
              this.documentEdit.docOCNumero = 0;
            }

            if (this.documentEdit.docEmpresaClave == undefined) {
              this.documentEdit.docEmpresaClave = "";
            }
            if (this.documentEdit.docFactura == undefined) {
              this.documentEdit.docFactura = "";
            }

            this.documentEdit.docProveedor = this.proveedor.userID;
            this.documentEdit.docTipoID = this.docuementoSeccion.documentoTipoID;
            this.documentEdit.docBucketKeyFile = resultS3.key;
            this.documentEdit.docFileExt = fileExtention;
            dataService
              .createDocument(this.documentEdit)
              .then((Response: ResponseData) => {
                if (Response.data.data[0]) {
                  this.$emit(
                    "notificacion",
                    "Registro agregado correctamente",
                    "success"
                  );
                  this.documentEdit.docID = Response.data.data[0].id;
                  this.documentEdit.docEstatusID = 1;
                  this.$emit("saveItem");
                } else {
                  this.$emit(
                    "notificacion",
                    "No se pudo agregar el registro, intente de nuevo más tarde",
                    "red darken-2"
                  );
                }
              })
              .catch((e: Error) => {
                this.$emit(
                  "notificacion",
                  "No se pudo agregar el registro" + e,
                  "red darken-2"
                );
              });
          } else {
            this.$emit(
              "notificacion",
              "No se pudo agregar el registro, intente de nuevo más tarde",
              "red darken-2"
            );
          }
        } else {
          this.$emit("notificacion", "Archivo requerido", "red darken-2");
        }
      }
    },
    // Limpiar archivo al desabilitar y habilitar edicion de este
    editFile() {
      this.documentEdit.docBucketKeyFile = null;
    },
  },
});
